import React, { useState, useEffect } from "react";
import { Avatar, Badge, Button } from "antd";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Container, Dropdown, Navbar, NavDropdown } from "react-bootstrap";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineLogout } from "react-icons/ai";
import { IoNotificationsSharp } from "react-icons/io5";
import { getProfileData } from "../../redux/actions/profileAction";
import { useSelector, useDispatch } from "react-redux";
import { baseUrl, profileFileUrl } from "../../redux/constants/const";
import {
  getNotification,
  readAllNotification,
} from "../../redux/actions/authAction";
import { toast } from "react-toastify";
import navLogo from "../../assets/logo2.png";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import "./header.css";
import axios from "axios";
import moment from "moment";

const activeStyle = {
  color: "#ae841e",
};
const LoginHeader = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { addToast } = useToasts()
  const [isOpen, setIsOpen] = useState(false);
  const [notifiData, setNotifiData] = useState("");
  const [notificationStatus, setNotificationStatus] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState("inactive");
  const profileData = useSelector((state) => state?.profileReducer?.user_data);

  const updateProfile = async () => {
    const country = window.navigator.language;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return axios.post(
      `${baseUrl}user/update_profile`,
      { country, timezone },
      { headers: { Authorization: "Bearer " + token } }
    );
  };

  const getNotifyData = () => {
    const successCb = (res) => {
      res?.data?.map((data) => setNotifiData(data));
    };
    dispatch(getNotification(successCb));
  };
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  const logOut = () => {
    toast.success("Logout Successfully", {
      appearance: "success",
      autoDismiss: true,
    });
    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
    // window.location.reload()
  };
  const readNotification = () => {
    const successCb = (res) => {
      setNotificationStatus(res?.status);
      navigate("/notification");
      getNotifyData();
    };
    const failureCb = () => {};
    dispatch(readAllNotification(successCb, failureCb));
  };

  useEffect(() => {
    dispatch(getProfileData());
    getNotifyData();
    updateProfile();
  }, []);

  // const checkSubscription = () => {
  //     let currentDate = moment().unix() * 1000;

  //     let nextPaymentDate = profileData?.user_subscription?.next_payment_date?.toString().length > 10 ? profileData?.user_subscription?.next_payment_date : profileData?.user_subscription?.next_payment_date * 1000;

  //     let purchasedDate = profileData?.user_subscription?.purchased_on?.toString().length > 10 ? profileData?.user_subscription?.purchased_on : profileData?.user_subscription?.purchased_on * 1000;
  //     let durationInDays = profileData?.user_subscription?.plan_id?.duration_in_days;

  //     const purchasedDateDiff = moment().diff(purchasedDate, 'days');

  //     if (purchasedDateDiff < durationInDays) {
  //         setSubscriptionStatus('active')
  //     } else {
  //         if (nextPaymentDate && (nextPaymentDate > currentDate)) {
  //             setSubscriptionStatus('active')
  //         }
  //     }
  // }

  // useEffect(() => {
  //     checkSubscription();
  // }, [])

  let purchasedDate =
    profileData?.user_subscription?.purchased_on?.toString().length > 10
      ? profileData?.user_subscription?.purchased_on
      : profileData?.user_subscription?.purchased_on * 1000;
  let durationInDays =
    profileData?.user_subscription?.plan_id?.duration_in_days;

  const purchasedDateDiff = moment().diff(purchasedDate, "days");

  const MySubscriptionHandler = () => {
    navigate(profileData?.is_academy_owner == 1 ? "/academy" : "/pricing");
  };

  return (
    <>
      <Navbar className="nav_back" expand="lg">
        <Container fluid className="fluid_content">
          <div className="d-flex justify-content-between align-items-center w-100 py-2">
            <img
              src={navLogo}
              alt="navLogo"
              className="nav_logo"
              onClick={() => navigate("/dashboard")}
              style={{ cursor: "pointer" }}
            />
            <div className="nav_links">
              <NavLink
                to="/dashboard"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Dashboard
              </NavLink>
              <NavLink
                to="/community"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Community
              </NavLink>
              <NavLink
                to="/journal"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Journal
              </NavLink>
              <NavLink
                to="/products"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Shop
              </NavLink>
              <NavLink
                to="/podcast"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Podcast
              </NavLink>
              <NavLink
                to="/blog"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Blog
              </NavLink>
              <NavLink
                to="/myorder"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                My orders
              </NavLink>
              {profileData?.user_subscription?.is_academy_subscription === 1 &&
              !profileData?.user_subscription?.academy_owner_id ? (
                <NavLink
                  to="/studentsubscription"
                  style={({ isActive }) => (isActive ? activeStyle : undefined)}
                >
                  Academy
                </NavLink>
              ) : (
                ""
              )}
            </div>
            <div className="d-flex align-items-center">
              {/* <div className="me-3 d-none d-lg-block" onClick={() => navigate('/notification')}> */}
              <div
                className="me-3 d-none d-lg-block"
                onClick={() => readNotification()}
              >
                {notifiData !== "" && notifiData?.is_read !== 0 ? (
                  <Badge status="error" dot>
                    <IoNotificationsSharp
                      style={{ cursor: "pointer", color: "#ae841e" }}
                    />
                  </Badge>
                ) : (
                  <IoNotificationsSharp
                    style={{ cursor: "pointer", color: "#ae841e" }}
                  />
                )}
              </div>
              <Dropdown className="login_none">
                <Dropdown.Toggle
                  className="d-flex align-items-center justify-content-center"
                  style={{ background: "#ae841e", border: "none" }}
                >
                  <div className="d-flex justify-content-center align-items-center">
                    {profileData?.profile_pic !== null ? (
                      <Avatar
                        size={{ xxl: 40 }}
                        src={`${profileFileUrl}${profileData?.profile_pic}`}
                      />
                    ) : (
                      <Avatar size={{ xxl: 40 }}>
                        {profileData?.name
                          ?.split(" ")
                          .map((name) => name[0])
                          .join("")
                          .toUpperCase()}
                      </Avatar>
                    )}
                    <div className="mx-1">
                      <span style={{ paddingRight: "1rem" }}>
                        {profileData?.name ?? "User"}
                      </span>
                    </div>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey="4.1" onClick={MySubscriptionHandler}>
                    My Subscription
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="4.1"
                    onClick={() => navigate("/profile")}
                  >
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="4.1" onClick={logOut}>
                    Logout
                    <AiOutlineLogout />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="burger_menu">
              <div className="d-flex align-items-center">
                <div className="me-2" onClick={() => readNotification()}>
                  {notifiData !== "" && notifiData?.is_read !== 0 ? (
                    <Badge status="error" dot>
                      <IoNotificationsSharp
                        style={{ cursor: "pointer", color: "#ae841e" }}
                      />
                    </Badge>
                  ) : (
                    <IoNotificationsSharp
                      style={{ cursor: "pointer", color: "#ae841e" }}
                    />
                  )}
                </div>
                <GiHamburgerMenu onClick={toggleDrawer} />
              </div>
            </div>
          </div>
          <Drawer
            open={isOpen}
            onClose={toggleDrawer}
            direction="right"
            className=""
          >
            <div className="mobile_links">
              {/* <Link to="/dashboard">Dashboard</Link>
                            <Link to="/community">Community</Link>
                            <Link to="/journal">Journal</Link>
                            <Link to="/products">Shop</Link>
                            <Link to="/podcast">Podcast</Link>
                            <Link to="/blog">Blog</Link>
                            <Link to="/myorder">My orders</Link> */}
              <NavLink
                to="/dashboard"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Dashboard
              </NavLink>
              <NavLink
                to="/community"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Community
              </NavLink>
              <NavLink
                to="/journal"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Journal
              </NavLink>
              <NavLink
                to="/products"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Shop
              </NavLink>
              <NavLink
                to="/podcast"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Podcast
              </NavLink>
              <NavLink
                to="/blog"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Blog
              </NavLink>
              <NavLink
                to="/myorder"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                My orders
              </NavLink>
              {profileData?.user_subscription?.is_academy_subscription == 1 &&
              !profileData?.user_subscription?.academy_owner_id ? (
                <NavLink
                  to="/studentsubscription"
                  style={({ isActive }) => (isActive ? activeStyle : undefined)}
                >
                  Academy
                </NavLink>
              ) : (
                ""
              )}
              {/* <div className='user_box'>
                                <div className="d-flex justify-content-center align-items-center" onClick={() => navigate('/profile')} >
                                    {profileData?.profile_pic !== "" ? <Avatar size={{ xxl: 40 }} src={`${profileFileUrl}${profileData?.profile_pic}`} /> :
                                        <Avatar size={{ xxl: 40 }}>{profileData?.name?.split(' ').map(name => name[0]).join('').toUpperCase()}</Avatar>
                                    }
                                    <div className="mx-1">
                                        <span style={{ paddingRight: "1rem" }}>{profileData?.name}</span>
                                    </div>
                                </div>
                                <NavDropdown><NavDropdown.Item eventKey="4.1" onClick={logOut}>Logout<AiOutlineLogout /></NavDropdown.Item></NavDropdown>
                            </div> */}
              <Dropdown>
                <Dropdown.Toggle
                  className="d-flex align-items-center justify-content-center"
                  style={{ background: "#ae841e", border: "none" }}
                >
                  <div className="d-flex justify-content-center align-items-center">
                    {profileData?.profile_pic !== "" ? (
                      <Avatar
                        size={{ xxl: 40 }}
                        src={`${profileFileUrl}${profileData?.profile_pic}`}
                      />
                    ) : (
                      <Avatar size={{ xxl: 40 }}>
                        {profileData?.name
                          ?.split(" ")
                          .map((name) => name[0])
                          .join("")
                          .toUpperCase()}
                      </Avatar>
                    )}
                    <div className="mx-1">
                      <span style={{ paddingRight: "1rem" }}>
                        {profileData?.name}
                      </span>
                    </div>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey="4.1" onClick={MySubscriptionHandler}>
                    My Subscription
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="4.1"
                    onClick={() => navigate("/profile")}
                  >
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="4.1" onClick={logOut}>
                    Logout
                    <AiOutlineLogout />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Drawer>
        </Container>
      </Navbar>
    </>
  );
};

export default LoginHeader;
